import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="m5.207 3.488.024.008 15.04 5.4c.273.097.514.184.696.268.163.074.427.208.573.476.169.31.174.685.013 1-.139.271-.4.412-.56.49-.18.089-.418.182-.689.287l-6.335 2.463-.063.025a7.215 7.215 0 0 0-.026.064l-2.463 6.335c-.105.27-.198.51-.286.689-.08.16-.22.421-.491.56-.315.16-.69.156-1-.013-.268-.146-.402-.41-.476-.573-.084-.182-.17-.423-.269-.696L3.496 5.23l-.008-.024a7.47 7.47 0 0 1-.195-.59c-.042-.16-.092-.41-.004-.665.108-.311.352-.555.663-.663.256-.088.504-.038.665.004.167.043.37.116.59.195Zm-.69 1.029.109.308 5.39 15.016c.056.157.102.283.141.387.042-.103.09-.228.151-.383l2.454-6.31.01-.025c.033-.086.082-.214.162-.326a1.07 1.07 0 0 1 .25-.25 1.446 1.446 0 0 1 .35-.172l6.31-2.454c.156-.06.281-.11.384-.151a18 18 0 0 0-.387-.141L4.825 4.626a21.865 21.865 0 0 0-.308-.11Z"
      clip-rule="evenodd"
    />
  </svg>
`;
